<template>
  <div class="simple-chart-container">
    <VueApexCharts
      :options="options"
      :color="colors"
      type="radialBar"
      height="auto"
      :series="series"
    />
    <div class="compare" :class="[isBelowZero === true ? 'text-danger' : 'text-success']" v-if="differentPercentage">
      <i class="fas" :class="[isBelowZero === true ? 'fa-arrow-down' : 'fa-arrow-up']"></i>
      {{differentPercentage.toFixed(2)}}%
    </div>
  </div>
</template>

<script>
/* eslint arrow-body-style: ["error", "as-needed"] */
/* eslint-disable arrow-parens */
/* eslint-env es6 */
import VueApexCharts from 'vue-apexcharts';

export default {
  props: {
    differentPercentage: {
      type: Number,
      default: 0,
    },
    width: {
      type: String,
      default: '500',
    },
    height: {
      type: String,
      default: 'auto',
    },
    series: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
    },
  },
  components: {
    VueApexCharts,
  },
  computed: {
    isBelowZero() {
      if (this.differentPercentage <= 0) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      options: {
        chart: {
          height: 350,
          type: 'radialBar',
        },
        fill: {
          type: 'solid',
        },
        stroke: {
          lineCap: 'round',
        },
        colors: ['#24D09C'],
        states: {
          normal: {
            filter: {
              type: 'none',
              value: 0,
            },
          },
          hover: {
            filter: {
              type: 'none',
              value: 0,
            },
          },
          active: {
            allowMultipleDataPointsSelection: false,
            filter: {
              type: 'none',
              value: 0,
            },
          },
        },
        plotOptions: {
          radialBar: {
            size: 180,
            inverseOrder: false,
            startAngle: 0,
            endAngle: 360,
            offsetX: 0,
            offsetY: 0,
            dataLabels: {
              show: true,
              name: {
                offsetY: +25,
                color: '#000',
                fontSize: '13px',
                show: true,
              },
              value: {
                offsetY: -15,
                color: '#000',
                fontSize: '30px',
                show: true,
              },
              total: {
                show: true,
                label: this.label,
                offsetY: +40,
                color: '#B5B5B5',
                fontSize: '6px',
              },
            },
          },
        },
        labels: ['Average Last 7 Days'],
        responsive: [
          {
            breakpoint: 1750,
            options: {
              chart: {
                height: 300,
                type: 'radialBar',
              },
              colors: ['#24D09C'],
              plotOptions: {
                radialBar: {
                  size: 180,
                  offsetY: 20,
                },
              },
              labels: ['Average Last 7 Days'],
            },
          },
          {
            breakpoint: 1600,
            options: {
              chart: {
                height: 300,
                type: 'radialBar',
              },
              colors: ['#24D09C'],
              plotOptions: {
                radialBar: {
                  size: 200,
                  offsetY: 0,
                },
              },
              labels: ['Average Last 7 Days'],
            },
          },
          {
            breakpoint: 1300,
            options: {
              chart: {
                // height: 120,
                type: 'radialBar',
              },
              colors: ['#24D09C'],
              plotOptions: {
                radialBar: {
                  size: 120,
                  offsetY: 0,
                  dataLabels: {
                    show: true,
                    name: {
                      offsetY: +20,
                      color: '#000',
                      fontSize: '10px',
                      show: true,
                    },
                  },
                },
              },
              labels: ['Average Last 7 Days'],
            },
          },
          {
            breakpoint: 1100,
            options: {
              chart: {
                // height: 120,
                type: 'radialBar',
              },
              colors: ['#24D09C'],
              plotOptions: {
                radialBar: {
                  size: 105,
                  offsetY: 0,
                  dataLabels: {
                    show: true,
                    name: {
                      offsetY: +20,
                      color: '#000',
                      fontSize: '10px',
                      show: true,
                    },
                    value: {
                      offsetY: -20,
                      color: '#000',
                      fontSize: '18px',
                      show: true,
                    },
                  },
                },
              },
            },
          },
          {
            breakpoint: 769,
            options: {
              plotOptions: {
                radialBar: {
                  size: 120,
                  offsetX: 0,
                  offsetY: -15,
                  dataLabels: {
                    show: true,
                    name: {
                      offsetY: +20,
                      color: '#000',
                      fontSize: '10px',
                      show: true,
                    },
                    value: {
                      offsetY: -20,
                      color: '#000',
                      fontSize: '18px',
                      show: true,
                    },
                  },
                },
              },
              labels: ['Average Last 7 Days'],
            },
          },
          {
            breakpoint: 576,
            chart: {
              events: {
                beforeMount: undefined,
                mounted: undefined,
                updated: undefined,
                click: undefined,
                mouseMove: undefined,
                legendClick: undefined,
                markerClick: undefined,
                selection: undefined,
                dataPointSelection: undefined,
                dataPointMouseEnter: undefined,
                dataPointMouseLeave: undefined,
                beforeZoom: undefined,
                zoomed: undefined,
                scrolled: undefined,
              },
            },
            options: {
              chart: {
                height: 230,
                type: 'radialBar',
              },
              plotOptions: {
                radialBar: {
                  size: 90,
                  offsetY: +10,
                  dataLabels: {
                    show: true,
                    name: {
                      offsetY: +10,
                      color: '#000',
                      fontSize: '8px',
                      show: true,
                    },
                    value: {
                      offsetY: -20,
                      color: '#000',
                      fontSize: '20px',
                      show: true,
                    },
                  },
                },
              },
            },
          },
        ],
      },
      colors: ['#FFFFFF'],
    };
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
.simple-chart-container {
  position: relative;
  .compare {
    position: absolute;
    top: 200px;
    left: 42%;
  }
}

@media (max-width: 575px) {
  .simple-chart-container {
    max-height: 100px;
    position: relative;
    .compare {
      position: absolute;
      top: 130px;
      left: 42%;
      font-size: $font-size-sm / 2;
    }
  }
}

@media (min-width: 576px) and (max-width: 768px) {
  .simple-chart-container {
    max-height: 200px;
    position: relative;
    .compare {
      position: absolute;
      top: 145px;
      left: 42%;
      font-size: $font-size-sm;
    }
  }
}

@media (min-width: 769px) and (max-width: 1300px) {
  .simple-chart-container {
    max-height: 200px;
    position: relative;
    .compare {
      position: absolute;
      top: 170px;
      left: 40%;
      font-size: $font-size-sm / 2;
    }
  }
}

@media (min-width: 1301px) and (max-width: 1599.98px) {
  .simple-chart-container {
    max-height: 300px;
    position: relative;
    .compare {
      position: absolute;
      top: 170px;
      left: 42%;
    }
  }
}

@media (min-width: 1600px) {
  .simple-chart-container {
    max-height: 300px;
    position: relative;
    .compare {
      position: absolute;
      top: 200px;
      left: 42%;
    }
  }
}
</style>
